import ReactDOM from "react-dom";
import React from "react";
import { Textarea as BaseTextArea } from "react-ui";

import { toHtmlElementOrNull } from "../../Commons/DOM/DomHelpers";

export const TextAreaTestPageObject = (
    value: undefined | string,
    textarea: React.RefObject<BaseTextArea>,
    container: React.RefObject<HTMLDivElement>,
    onChange: (nextValue: string) => void
) => ({
    getType: () => "TextArea",

    getValue: () => value,

    setValue: (currentValue: string): void => {
        onChange(currentValue);
    },

    isFocused: () => {
        if (textarea.current == undefined) {
            return false;
        }
        const textAreaElement = toHtmlElementOrNull(ReactDOM.findDOMNode(textarea.current));
        if (textAreaElement == undefined) {
            return false;
        }
        const textareaElement = textAreaElement.querySelector("textarea");

        return document.activeElement === textareaElement;
    },

    isInView: (): boolean => {
        if (container.current == undefined) {
            return false;
        }
        const rect = container.current.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= document.documentElement.clientHeight &&
            rect.right <= document.documentElement.clientWidth
        );
    },
});
